import { connect } from 'react-redux';
import { ImportDeductionCodePresenter } from './import-deduction-code.view';
import { importDeductionCodes } from '../../resources/deduction-codes/deduction-codes.actions';

export const ImportDeductionCode = connect(null, {
  importDeductionCodes,
})(ImportDeductionCodePresenter);
